var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btns"},[_c('div',{attrs:{"id":"goToTop"},on:{"click":_vm.scrollToTop}},[_c('a',{staticClass:"shadow-sm"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-up']}}),_c('span',[_vm._v("TOP")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }